__turbopack_context__.v({
  "btn-center": "_7Kriqa_btn-center",
  "btn-col--center": "_7Kriqa_btn-col--center",
  "btn-col--left": "_7Kriqa_btn-col--left",
  "btn-col--right": "_7Kriqa_btn-col--right",
  "btn-right": "_7Kriqa_btn-right",
  "buttonBlock": "_7Kriqa_buttonBlock",
});
